<template>
  <Wrapper
    id="games-accounts-edit"
    :header="$t('_web_profile-edit_games-header', 'Favourite Games')"
    :dummy="dummy"
    class="wrapper-padding-sm"
  >
    <b slot="headerButton" class="font-size-base">
      <a href="#" @click.prevent="clear">{{
        $t('_web_account-edit_games_clear-all', 'Clear All')
      }}</a>
    </b>
    <GamesWithGenres
      ref="gamesWithGenres"
      :value="accountEditData.games || []"
      @input="updateGames"
    />
  </Wrapper>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import Wrapper from '../../PanelWrapper';
import GamesWithGenres from '@/components/form/GamesWithGenresMultiSelect';

export default {
  name: 'AccountEditGames',
  components: {
    Wrapper,
    GamesWithGenres,
  },
  data() {
    return {
      dummy: null,
    };
  },
  computed: {
    ...mapGetters(['accountEditData']),
  },
  created() {
    this.fetchGames();
  },

  methods: {
    ...mapActions(['fetchGames']),
    ...mapMutations(['updateEditData']),
    updateGames(games) {
      this.updateEditData({ games });
    },
    clear() {
      if (this.$refs.gamesWithGenres) {
        this.$refs.gamesWithGenres.clear();
      }
    },
  },
};
</script>
<style lang="scss">
@media (max-width: 767px) {
  .wrapper-padding-sm {
    padding: 12px !important;
  }
}
</style>
